import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a59493b0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a59493b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59493b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a59493b0')) {
      api.createRecord('a59493b0', component.options)
    } else {
      api.reload('a59493b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a59493b0&scoped=true", function () {
      api.rerender('a59493b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkCheckbox/index.vue"
export default component.exports